<template>
  <div id='prodSettBG'>
  <div id="prodSetP" class="ui container">
    <p>&nbsp;</p>

    <h1 class="ui inverted grey header" style="position:relative;text-shadow:#333 1px 2px 3px;">
      <i class="cubes icon"></i>
      <div class="content" style="">
        Product Tracking Settings
      </div>
      <button v-if="$root.anySellerAccountSetupCompleted" class="small ui compact button" style="position:absolute;right:0px;top:12px;" v-on:click="$router.push($root.defaultPath)"><i class="left chevron icon"></i>Back</button>
    </h1>

    <div v-if="loadingdata" class="sentrk_s" style="margin: 150px auto;"></div>

    <div v-if="loadError && !loadingdata" class="ui negative message">
      <div class="header">Could not load product tracking settings</div>
      <p>{{ loadError }}</p>
      <button type="button" class="ui button" @click="fetchProductTrackingSettings">Retry</button>
    </div>

    <div v-if="!$root.anySellerAccountSetupCompleted" class="ui info  message">
      <div class="header">
        First time here?
      </div>
      <ul class="list">
        <li>Products that sold at least one unit in the last few weeks appear here.</li>
        <li>This list keeps updating automatically. Easy.</li>
        <li>"Ignore" products you are not interested in following. We preselected the ones seemingly not selling much.</li>
      </ul>
    </div>

    <div v-if="!$root.anySellerAccountSetupCompleted" class="ui info  message">
      <div class="header">
        About these marketplaces
      </div>
      <ul class="list">
        <li>Once we detect activity in a new marketplace it will appear here too.</li>
      </ul>
    </div>

    <div v-show="!loadingdata && !loadError" class="ui attached segment">
      <div style="min-height:40px;">
        <div class="ui input left floated menu">
          <input type="search" v-model="filterText" v-prevent-autofill="filterText" placeholder="Filter by ASIN, Title or Short-Hand Name" size="40" />
        </div>
        <pagination v-if="maxPage > 0" :currentPage="currentPage" :maxPage="maxPage" :currentPageRequested="currentPageRequested"
          v-on:back-to-1="currentPageRequested = 0"
          v-on:back="currentPageRequested = Math.max(0, currentPage-1)"
          v-on:forward="currentPageRequested = Math.min(maxPage, currentPage+1)"
          v-on:forward-all-the-way="currentPageRequested = maxPage"/>
      </div>
    </div>
    <div v-show="!loadingdata && !loadError" class="ui attached segment" v-for="acc in deepVisible" :key="acc.sellerId">
      <h4>Account {{acc.name}}</h4>
      <hr />
      <table v-bind:class="'ui very basic ' + (acc.products == null ? 'blurring dimmable ' : '') + 'table'">
        <div class="ui inverted dimmer">
          <div class="content">
            <div class="center">
              <span class="black text">Syncing your account from Amazon, this may take a while..</span>
            </div>
          </div>
        </div>
        <thead>
          <tr>
            <th class="center aligned">&nbsp;&nbsp; Ignore &nbsp;&nbsp;</th>
            <th></th>
            <th>Title / Short-Hand Name on SentryKit </th>
          </tr>
        </thead>
        <tbody v-if="acc.products != null && acc.products.length > 0">
          <product-row v-for="p in acc.products" :key="p.productId" :product="p" :automaticallyTrackNewProducts="automaticallyTrackNewProducts" v-on:shortName-changed="onShortNameChange($event)" v-on:show-changed="onShowChange($event)" />
        </tbody>
        <tbody v-else-if="acc.products != null">
          <td colspan="6" class="ui center aligned">Could not detect any products with recent sale</td>
        </tbody>
        <tbody v-else>
          <td><i class="us flag"></i></td>
          <td>Image</td>
        </tbody>
      </table>
    </div>
    <div v-show="!loadingdata && !loadError" class="ui attached message">
      <div class="ui grid">
        <div class="row">
          <div class="ten wide column">
            <div style="margin-bottom:16px">{{activeCount}} tracked listings<span v-if="activeCount != originalActiveCount"> (*)</span></div>
            <div v-show="automaticallyTrackNewProducts" class="ui right pointing blue basic label" style="background-color: #fff !important;">Important</div>
            <div class="ui checkbox">
              <input type="checkbox" data-lpignore="true" v-model="automaticallyTrackNewProducts" name="automaticallyTrackNewProducts" />
              <label>Automatically track new products upon first sale</label>
            </div>
            <div v-show="!automaticallyTrackNewProducts" class="ui left pointing orange label">
              <span data-inverted="" data-tooltip="Keep this ON, especially for new accounts" data-position="top right">
              Recommended setting: ON
              </span>
            </div>
          </div>
          <div class="six wide column" v-if="maxPage > 0">
            <pagination v-if="maxPage > 0" :currentPage="currentPage" :maxPage="maxPage" :currentPageRequested="currentPageRequested"
              v-on:back-to-1="currentPageRequested = 0"
              v-on:back="currentPageRequested = Math.max(0, currentPage-1)"
              v-on:forward="currentPageRequested = Math.min(maxPage, currentPage+1)"
              v-on:forward-all-the-way="currentPageRequested = maxPage"/>
          </div>
        </div>
      </div>
    </div>
    <br v-show="!loadingdata && !loadError" />

    <button v-show="!loadingdata && !loadError" class="ui primary button" :class="{'loading':savingdata}" v-on:click="save">Save</button>
    <button v-show="!loadingdata && !loadError" class="ui button" v-if="$root.anySellerAccountSetupCompleted" v-on:click="$router.push($root.defaultPath)">Cancel</button>

    <div v-show="!loadingdata && !loadError" style="float:right;" data-inverted="" data-tooltip="Bulk-edit your Product Settings in a spreadsheet" data-position="top center">

      <div class="ui right pointing purple label" style="margin-right:20px;">New</div>

      <button class="ui labeled icon button" v-on:click="exportExcel" >
        <i class="download icon"></i>Export
      </button>
      <span>
        <label for="hidden-product-import-file" class="ui labeled icon button" v-on:click="resetFiles">
          <i class="upload icon"></i>Import
        </label>
        <input type="file" id="hidden-product-import-file" style="display: none" v-on:change="importExcel">
      </span>
    </div>

    <p>&nbsp;</p>

    <div class="ui positive message">
      <div class="header">
        Pro Tip
      </div>
      <ul class="list">
        <li>It is a good idea to set a Short-Hand name for your products. This is how we display your products on SentryKit and all emails.</li>
        <li>We recommend doing this now but you can always come back here later. Check out the menu on top right corner.</li>
      </ul>
    </div>

    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>

  </div>
  </div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import ProductRow from './components/productsettings/ProductSettingsPage.ProductRow'
import Pagination from './components/productsettings/ProductSettingsPage.Pagination'

export default {
  components: {
    ProductRow,
    Pagination,
  },
  data: function () {
    return {
      flattened: [],
      deepTotal: [],
      deepVisible: [],
      loadingdata: false,
      savingdata: false,
      activeCount: 0,
      originalActiveCount: 0,
      pageSize: 50,
      currentPage: 0,
      currentPageRequested: 0,
      maxPage: 0,
      productMap: {},
      accountsSetupPending: [],
      automaticallyTrackNewProducts: false,
      originalAutomaticallyTrackNewProducts: false,
      filterText: null,
      filterTextLastModifiedAt: null,
      loadError: null,
    }
  },
  created: function () {
    window.dirty = false
  },
  mounted: function () {
    this.fetchProductTrackingSettings()
  },
  watch: {
    currentPageRequested: function (val) {
      this.deepVisible = this.refreshPage(val)
      this.currentPage = val
    },
    automaticallyTrackNewProducts: function (val) {
      if (this.originalAutomaticallyTrackNewProducts !== this.automaticallyTrackNewProducts) {
        window.dirty = true
      }
    },
    filterText: function (val) {
      const filterTextLastModifiedAt = Date.now()
      this.filterTextLastModifiedAt = filterTextLastModifiedAt
      setTimeout(() => this.filterTextTimedOut(val, filterTextLastModifiedAt), 500)
    },
  },
  methods: {
    /** GET /api/product/settings — product tracking (ignore/show, short names, auto-track new). */
    productTrackingSettingsUrl: function () {
      return '/api/product/settings'
    },
    fetchProductTrackingSettings: function () {
      this.loadingdata = true
      this.loadError = null
      const url = this.productTrackingSettingsUrl()
      this.$http.get(url).then((response) => {
        this.flattened = []
        this.deepTotal = []
        this.deepVisible = []
        this.productMap = {}
        this.loadError = null
        this.loadingdata = false
        const body = response.body || {}
        const sellerAccounts = body.sellerAccounts || []
        this.accountsSetupPending = sellerAccounts.filter(a => !a.setupCompleted).map(a => a.sellerId)
        for (let i = 0; i < sellerAccounts.length; ++i) {
          const sellerAcc = sellerAccounts[i]
          this.deepTotal.splice(this.deepTotal.length, 0, sellerAcc)
          const products = sellerAcc.products || []
          for (let j = 0; j < products.length; ++j) {
            const p = products[j]
            this.flattened.splice(this.flattened.length, 0, [i, j])
            p['shortNameOrig'] = p.shortName
            p['showOrig'] = p.show
            p['activeOrig'] = p.active
            this.productMap[p.productId] = p
          }
        }
        this.maxPage = Math.ceil(this.flattened.length / this.pageSize) - 1
        this.deepVisible = this.maxPage > 0 ? this.refreshPage(this.currentPage) : this.deepTotal
        this.originalActiveCount = Object.values(this.productMap).filter(p => p.show).length
        this.activeCount = this.originalActiveCount
        this.originalAutomaticallyTrackNewProducts = body.automaticallyTrackNewProducts
        this.automaticallyTrackNewProducts = this.originalAutomaticallyTrackNewProducts
        const self = this
        Vue.nextTick(function () {
          $(self.$el).find('.dimmable').dimmer({
            closable: false,
          }).dimmer('show')
        })
      }, (err) => {
        this.loadingdata = false
        const msg = (err.body && err.body.message) || err.statusText || ('Request failed' + (err.status ? ' (' + err.status + ')' : ''))
        this.loadError = msg
      })
    },
    refreshPage: function (currentPage) {
      const deepVisible = []
      for (let i = 0; i < this.deepTotal.length; ++i) {
        const sellerAcc = this.deepTotal[i]
        deepVisible.splice(deepVisible.length, 0, {sellerId: sellerAcc.sellerId, name: sellerAcc.name, products: []})
      }
      const flattened = this.filteredFlattened()
      for (let i = currentPage * this.pageSize; i < Math.min(flattened.length, (currentPage + 1) * this.pageSize); ++i) {
        const index = flattened[i]
        const sellerAcc = this.deepTotal[index[0]]
        const p = sellerAcc.products[index[1]]
        const products = deepVisible[index[0]].products
        products.splice(products.length, 0, p)
      }
      window.dirty = false
      if (!this.filteredText) return deepVisible.filter(s => s.products.length > 0)
      return deepVisible
    },
    onShortNameChange: function (event) {
      const i = this.productMap[event.productId]
      if (i.shortName !== event.shortName) {
        i.shortName = event.shortName
        window.dirty = true
      }
    },
    onShowChange: function (event) {
      const i = this.productMap[event.productId]
      if (i.show === event.show) {
        return
      }
      const show = i.show
      i.show = event.show
      i.active = (event.show !== null) ? event.show : null
      if (i.show && !show) {
        this.activeCount++
      } else if (!i.show && show) {
        this.activeCount--
      }
      window.dirty = true
    },
    save: function () {
      const result = []
      const productIds = Object.keys(this.productMap)
      for (let i = 0; i < productIds.length; ++i) {
        const productId = productIds[i]
        const p = this.productMap[productId]
        const shortNameChanged = p.shortName !== p.shortNameOrig
        const showChanged = p.show !== p.showOrig || p.activeOrig !== p.active
        if (shortNameChanged || showChanged) {
          const r = {productId: productId}
          if (shortNameChanged) r['shortName'] = p.shortName
          if (showChanged) {
            if (p.active === null) {
              r['ignoredUntilNextOrder'] = true
              r['show'] = false
            } else {
              if (p.activeOrig === null) r['ignoredUntilNextOrder'] = false
              r['show'] = p.show
            }
          }
          result.splice(result.length, 0, r)
        }
      }
      const data = {
        products: result,
        accountsSetupDone: this.accountsSetupPending,
        automaticallyTrackNewProducts: this.originalAutomaticallyTrackNewProducts !== this.automaticallyTrackNewProducts ? this.automaticallyTrackNewProducts : null,
      }
      const hadPendingAccountSetup = this.accountsSetupPending.length > 0
      this.savingdata = true
      this.$http.put(this.productTrackingSettingsUrl(), data).then((response) => {
        window.dirty = false
        this.$parent.stateOfTheWorld()
        const ids = Object.keys(this.productMap)
        for (let i = 0; i < ids.length; ++i) {
          const p = this.productMap[ids[i]]
          p.shortNameOrig = p.shortName
          p.showOrig = p.show
          p.activeOrig = p.active
        }
        this.originalAutomaticallyTrackNewProducts = this.automaticallyTrackNewProducts
        this.originalActiveCount = this.activeCount
        this.accountsSetupPending = []
        if (hadPendingAccountSetup) {
          this.$root.anySellerAccountSetupCompleted = true
        }
        this.savingdata = false
      }, (response) => {
        this.savingdata = false
      })
    },
    exportExcel: function () {
      window.open('/api/product/spreadsheet/v1.0/export', '_self')
    },
    importExcel: function (e) {
      if (!e.target.files) return
      const formData = new FormData()
      formData.append('file', e.target.files[0], 'product-import.xlsx')
      this.$http.post('/api/product/spreadsheet/v1.0/import', formData, {
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(resp => {
        this.resetFiles()
        this.deepTotal = []
        this.deepVisible = []
        this.flattened = []
        this.productMap = {}
        this.currentPage = 0
        this.activeCount = 0
        this.originalActiveCount = 0
        this.currentPageRequested = 0
        this.maxPage = 0
        this.accountsSetupPending = []
        this.automaticallyTrackNewProducts = false
        this.originalAutomaticallyTrackNewProducts = false
        this.fetchProductTrackingSettings()
      })
    },
    resetFiles: function () {
      $('#hidden-product-import-file').val('')
    },
    filteredFlattened: function () {
      if (!this.filterText) return this.flattened
      const regexp = new RegExp('^.*' + this.filterText.toLowerCase().split(' ').filter(a => a.length > 0).map(a => a.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('.*') + '.*$')
      return this.flattened.filter(f => {
        const p = this.deepTotal[f[0]].products[f[1]]
        return (p.asin1 && regexp.test(p.asin1.toLowerCase())) || (p.shortName && regexp.test(p.shortName.toLowerCase())) || (p.productName && regexp.test(p.productName.toLowerCase()))
      })
    },
    filterTextTimedOut: function (filterText, filterTextLastModifiedAt) {
      if (this.filterText !== filterText || this.filterTextLastModifiedAt !== filterTextLastModifiedAt) return
      this.currentPage = 0
      this.currentPageRequested = 0
      this.maxPage = Math.ceil(this.filteredFlattened().length / this.pageSize) - 1
      this.deepVisible = this.refreshPage(0)
    },
  },
  beforeRouteLeave (to, from, next) {
    if (!window.dirty) {
      next()
    } else if (window.confirm('Please confirm that you want to close your Product Settings.\nYou have some unsaved changes.')) {
      window.dirty = false
      next()
    }
  }
}
</script>

<style>
#prodSetP .ui.inverted.dimmer > .content > .center > span.black.text { color: #000; }
#prodSetP {
  max-width: 960px;
  width: 100%;
  box-sizing: border-box;
}
#prodSettBG {
  min-height: 100vh;
  background:radial-gradient(ellipse at center, rgba(213,213,213,1) 0%, rgba(77,77,77,1) 100%);
}
#prodSetP .inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
</style>



// WEBPACK FOOTER //
// ProductSettingsPage.vue?b1d33f70